import { useEffect, useState } from 'react';
import './ProjectTabs.less';
export default function Tabs(props) {
  const [tabs] = useState(props.tabs);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  useEffect(() => {}, []);
  return (
    <div className="project-tabs">
      {tabs.map((item, i) => {
        return (
          <div
            onClick={() => {
              if (!props.disabled) {
                setActiveTab(item);
                props.onChange(item, i);
              }
            }}
            className={'tab-item ' + (activeTab === item ? 'active' : '')}
            key={item.name}>
            <span className="name">{item}</span>
          </div>
        );
      })}
    </div>
  );
}
